import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Box, Select, Text } from 'grommet';

const styles = {
  pointer: {
    cursor: 'pointer'
  },
  chips: {
    marginLeft: '5px'
  }
};

const selectOptions = [
  'Default',
  'Name a-z',
  'Job Title a-z',
  'Compensation (high to low)',
  'Distance (near to far)'
];

const defaultState = {
  selectSortBy: 'Sort By'
}


class Menu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {...defaultState};
  }

  changeSortState = (sortState) => {
    this.setState({...this.state, sortState})
  }
   
  handleChangeSelect(selectSortBy) {
    // const { changeSortState } = this.props;
    this.setState({selectSortBy});
    this.changeSortState(selectSortBy);
  }

  handleClearFilter(option) {
    // const { clearFilter } = this.props;
    // clearFilter(option);
  }

  render() {
    const { options, classes, toggleSavedGigs } = this.props;
    const { selectSortBy } = this.state;
    return (
      <Box direction="row" margin={{'bottom': '20px'}} pad={{'horizontal': '20px', 'vertical': '10px'}} justify="between">
        <Box direction="row">
          {
            options && options.map((option, index) => {
              return (
                <Box background="silver" pad={{'horizontal': '10px', 'vertical': '5px'}} margin={{'right': '10px'}} key={index} direction="row" align="center" className={classes.pointer}>
                  {option.name}
                  <i className={'fa fa-times ' + classes.chips} onClick={() => this.handleClearFilter(option)}></i>
                </Box>
              )
            })
          }
        </Box>
        <Box direction="row">
          <Select
            options={selectOptions}
            value={selectSortBy}
            onChange={({ option }) => {this.handleChangeSelect(option)}}
          />
        </Box>
          <Box direction="row" align="center" margin={{'left': '20px'}} className={classes.pointer} onClick={toggleSavedGigs}>
            <Text margin={{'right': '10px'}}>My Saved Gigs</Text>
            <i className="fa fa-heart"></i>
          </Box>

      </Box>);
  }
}

Menu.propTypes = {
  classes: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  clearFilter: PropTypes.func.isRequired,
  toggleSavedGigs: PropTypes.func.isRequired,
  // changeSortState: PropTypes.func.isRequired
}

export default withStyles(styles)(Menu)
